import React, { useContext } from "react";
import { observer } from "mobx-react";

import { BetDetailsModalStoreContext } from "@state/context/my-bets/BetDetailsModalStoreContext";

import { BetDetailsModalStore } from "@state/stores/my-bets/BetDetailsModalStore";
import { CashoutStore } from "@state/stores/my-bets/CashoutStore";

export const CashOutCounter = observer(function CashOutCounter() {
	const store = useContext(BetDetailsModalStoreContext);

	let cashoutStore: CashoutStore;

	if (store instanceof BetDetailsModalStore) {
		cashoutStore = store.myBetsStore.cashoutStore;
	} else {
		cashoutStore = store.cashoutStore;
	}

	if (store == null) {
		return null;
	}

	// btn--icon inc
	if (cashoutStore?.countdownCounter > 0) {
		return (
			<div className="popup__loader">
				<strong className="loader--centered__countdown">
					{cashoutStore.countdownCounter}
				</strong>
			</div>
		);
	}

	return null;
});
